import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { CheckboxSlider } from 'ui-components/components/checkbox-slider';
import { Tooltip } from 'ui-components/components/tooltip';

import style from './style.module.less';
import { messages } from './messages';

export const SharePackingSlip = ({ isPackingSlipSharing = false, packingSlipSharingChanged }) => {
  const intl = useIntl();

  return (
    <div className={style.pointer}>
      <CheckboxSlider
        checkboxId='packing-slips-sharing-toggle'
        checked={isPackingSlipSharing}
        className={style.checkbox}
        onChange={packingSlipSharingChanged}
      />
      <span className={style['slider-description']} onClick={packingSlipSharingChanged}>
        <FormattedMessage {...messages.packingSlipSharing} />
      </span>
      <Tooltip position='right' text={intl.formatMessage(messages.packingSlipSharingTooltip)}>
        <span>
          <FontAwesomeIcon className={style['info-icon']} icon={faInfoCircle} />
        </span>
      </Tooltip>
    </div>
  );
};

SharePackingSlip.propTypes = {
  packingSlipSharingChanged: PropTypes.func.isRequired,
  isPackingSlipSharing: PropTypes.bool,
};
